<template>
  <div class="job_detail train_detail" v-loading="loading" element-loading-text="拼命加载中">
    <div class="header">
      <div class="header_content">
        <div class="header_bottom relative">
          <div class="share relative">
            <span>分享到 <i class="el-icon-arrow-down"></i></span>
            <Share :url="shareUrl" :title="detail.trainName" :desc="'由'+detail.trainOrgOutDto.name+'发布'" v-if="detail.trainOrgOutDto"></Share>
          </div>
          <h1>{{ detail.name }}</h1>
          <p class="type" v-if="detail.disType">
            适合 <span v-for="(item,index) in detail.disType" :key="index">{{ item }}</span>
          </p>
          <div class="number">
            <span>{{ detail.applyNums }}人报名</span>/招生{{ detail.nums }}人
          </div>
          <div class="down flex">
            <div class="times">
              <p>
                <span v-if="detail.edu">{{detail.edu}}<el-divider direction="vertical"></el-divider></span>
                <span v-if="detail.exp">{{detail.exp}}<el-divider direction="vertical"></el-divider></span>
                <span v-for="(n,i) in detail.disabledTypes" :key="i">{{n}}</span>
              </p>
              <p>
                报名时间：<span>{{ detail.applyStart }} 至 {{ detail.applyEnd }}</span>
              </p>
              <p>
                培训地点：<span>{{ detail.addrProvince + detail.addrCity + detail.addrThreeCity + detail.addrDetail }}</span>
              </p>
            </div>

            <div class="buttons" v-if="detail.lhjyApply">
              <el-button @click="collection()">
                <img
                    :src="detail.isCollection == '1'?require('@/static/public/collected.png'):require('@/static/public/collect.png')"
                    alt="" class="img inline_block">
                {{ detail.isCollection == '1' ? '已收藏' : '收藏' }}
              </el-button>
              <el-button type="primary"  @click="delivery('id')" v-if="detail.lhjyApply.auditStatus == -1">
                <span>立即报名</span>
              </el-button>
              <el-button type="primary"  disabled v-else>
                <span>不可报名</span>
              </el-button>
<!--              <el-button type="primary" disabled v-else>-->
<!--                <span v-if="detail.lhjyApply.dictJson">{{ detail.lhjyApply.dictJson.auditStatus }}</span>-->
<!--                <span v-else>不可报名</span>-->
<!--              </el-button>-->
              <span class="err_tip" v-if="detail.lhjyApply.auditStatus == 2">{{detail.lhjyApply.auditMsg}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content flex">
      <div class="content_left">
        <div class="title">
          <h2>培训详情</h2>
        </div>
        <div class="text" v-html="detail.detail">
        </div>
      </div>
    </div>
    <login-prompt :goShow="isHide" @close="handleClose" title="职位申请" :text="loginText"></login-prompt>
    <el-dialog
        title="培训收藏"
        :visible.sync="dialogVisible"
        width="480px"
        :before-close="handleClose">
      <div class="el-dialog_content text_c">
        <div class="title marB5">
          <img src="@/static/public/success.png" alt="" class="img">
          培训收藏成功！
        </div>
        <p>您可以在
          <router-link to="/center/collect/?active=1" target="_blank" class="color00">灵活就业收藏夹</router-link>
          中查看
        </p>
      </div>
      <div slot="footer" class="dialog-footer text_c">
        <el-button type="primary" @click="dialogVisible = false">知道了</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="报名培训"
        :visible.sync="dialogVisibles"
        width="590px"
        :before-close="handleClose">
      <div class="world el-dialog_content">
        <el-form ref="form" :model="goForm" :rules="err" label-width="80px" class="form">
          <el-form-item label="姓名" required>
            <el-input v-model="goForm.name" disabled class="w430"></el-input>
          </el-form-item>
          <el-form-item label="性别" required>
            <el-input v-model="goForm.gender" disabled class="w430"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" required>
            <el-input v-model="goForm.linkPhone" placeholder="没有绑定手机号请点击去修改绑定手机" disabled class="w350"></el-input>
            <router-link to="/setting/" target="_blank" class="color00 marL15">去修改</router-link>
          </el-form-item>
          <el-form-item label="残疾类别" required>
            <ThreeLink
                :codeType="'disabled_type'"
                :codeLevel="'3'"
                placeholder="请选择残疾类别"
                class="w430"
                disabled
                :defaultValue="[goForm.disabledType,goForm.disabledLevel,goForm.disabledDetail]"
            ></ThreeLink>
          </el-form-item>
          <el-form-item label="出生年月" required>
            <el-input v-model="goForm.date" disabled class="w430"></el-input>
          </el-form-item>
          <el-form-item label="籍贯" required>
            <el-input v-model="goForm.address" disabled class="w430"></el-input>
          </el-form-item>
          <el-form-item label="学历" prop="edu">
            <MulSelect
                :code="'user_edu'"
                class="w430"
                placeholder="请选择你的学历"
                @setMValue="setSelectValue($event,'edu')"
                :defaultValue="goForm.edu"
            ></MulSelect>
          </el-form-item>
          <el-form-item label="工作经验" prop="exp">
            <MulSelect
                :code="'user_word'"
                class="w430"
                placeholder="请选择工作经验"
                @setMValue="setSelectValue($event,'exp')"
                :defaultValue="goForm.exp"
            ></MulSelect>
          </el-form-item>
          <el-form-item label="注册地址" prop="provinceid" v-if="false">
            <ThreeLink
                :codeType="'provinceid'"
                :codeLevel="'3'"
                placeholder="请选择工作地点"
                class="w430"
                @setMValue="setScasValue($event,goForm,['provinceid','cityid','threeCityid'])"
                :defaultValue="[goForm.provinceid,goForm.cityid,goForm.threeCityid]"
            ></ThreeLink>
          </el-form-item>
          <el-form-item label="居住地址" prop="address" v-if="false">
            <el-input v-model="goForm.address" class="w430"></el-input>
          </el-form-item>
        </el-form>
        <div class="tips">
          *请您核对信息，如信息有误请更新您的简历信息
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisibles = false" plain>取 消</el-button>
        <el-button type="primary" @click="save">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import loginPrompt from '@/components/public/loginPrompt'
import MulSelect from "@/components/selectComponents/MulSelect";
import ThreeLink from "@/components/selectComponents/ThreeLink";
import edit from '@/components/public/editor';
import Share from '@/components/public/Collect'
export default {
  name: "trainDetail",
  components: {
    loginPrompt,
    edit,
    MulSelect,
    ThreeLink,
    Share
  },
  data() {
    return {
      detail: [],
      adList: [],
      collect: false,
      disabled:false,
      disabledText:'立即报名',
      blod:false,
      goForm: {
        fwjgTrainId: '',
        name: '',
        gender: '',
        disabledType: '',
        disabledLevel: '',
        disabledDetail: '',
        date: '',
        edu: '',
        exp: '',
        address: '',
      },
      err: {
        edu: [
          {required: true, message: '学历不能为空', trigger: 'change'},
        ],
        exp: [
          {required: true, message: '工作经验不能为空', trigger: 'change'},
        ],
      },
      isHide: false,
      dialogVisible: false,
      dialogVisibles: false,
      loading: false,
      isLogin: '',
      loginText: '',
      shareUrl:'',
      locationP:'',
    }
  },
  methods: {
    async info() {
      this.loading = true;
      try {
        let res = await this.$axios.get('/api/app-jycy-henan/henan/lhjy/detail/'+this.$route.query.id);
        this.isLogin = this.$store.state.userType || JSON.parse(localStorage.getItem('userType'));
        this.detail = res.data.data;
        this.shareUrl = window.location.href;
        this.loading = false;
        if (this.detail.statusTag == '未开始'){
          this.disabledText = '未开始报名';
        }else if (this.detail.statusTag == '已结束'){
          this.disabledText = '报名已截止';
        }
      } catch (e) {
        this.loading = false;
      }
    },
    //收藏
    collection() {
      if (this.isLogin) {
        this.$axios.get('/api/app-jycy-henan/henan/lhjy/collect/'+this.detail.id).then(res => {
          if (res.data.success) {
            if (this.detail.isCollection == '0') {
              this.dialogVisible = true;
              this.detail.isCollection = '1';
            } else {
              this.detail.isCollection = '0';
              this.$message.warning(res.data.msg);
            }
          }
        })
      } else {
        this.isHide = true;
        this.loginText = '登录后才可以收藏！'
      }
    },
    //报名信息回显
    delivery() {
      if (this.isLogin) {
        this.$api.getMyInfo().then(res => {
          if (res.data.success) {
            this.dialogVisibles = true;
            let ref = res.data.data;
            this.goForm.name = ref.userName;
            this.goForm.gender = ref.sex;
            this.goForm.disabledDetail = ref.disabledType[0].disabledDetail ;
            this.goForm.disabledLevel  = ref.disabledType[0].disabledLevel;
            this.goForm.disabledType = ref.disabledType[0].disabledType;
            this.goForm.address = ref.provinceid+ref.cityid;
            this.goForm.date = ref.birthday;
            this.goForm.edu = ref.edu;
          }
        })
      } else {
        this.isHide = true;
        this.loginText = '登录后才可以报名！'
      }
    },
    //报名
    save() {
      this.$refs.form.validate(async (valid) => {
        try {
          if (valid) {
            let res = await this.$axios.get('/api/app-jycy-henan/henan/lhjy/apply/'+this.detail.id);
            if (res.data.success) {
              this.detail.lhjyApply.auditStatus = 0;
              this.dialogVisibles = false;
              this.$message.success(res.data.msg);
            } else {
              this.$message.error(res.data.msg);
            }
          } else {
            this.$message.error(valid);
            return false;
          }
        } catch (e) {
          this.$message.error("错误");
        }
      })
    },
    setScasValue(event, form, keys) {
      for (let i = 0; i < keys.length; i++) {
        let value = event[i];
        if (!value) {
          value = "";
        }
        let key = keys[i];
        form[key] = value;
      }
    },
    setSelectValue(val, key) {
      this.goForm[key] = val;
    },
    handleChange() {

    },
    handleClose() {
      this.isHide = false;
      this.dialogVisible = false;
      this.dialogVisibles = false;
    },
  },
  created() {
    this.info();
    //判断是否移动端
    this.$mobile('https://m.cdpee.org.cn/#/pages/train/detail?id='+this.$route.query.id);
    this.locationP = localStorage.getItem("locationProvince");
  },
  mounted() {
    this.$emit('goRouter', '/training/')
  }
}
</script>

<style scoped lang="less">
@import "~assets/css/job.less";
@import "~assets/css/train.less";
.train_detail{
  padding-top: 10px;
  .header{
    padding-top: 20px;
    .buttons{
      position: relative;
      .err_tip{
        position: absolute;
        top: 55px;
        right: 30%;
        transform: translateX(30%);
        color: #ff0000;
      }
    }
  }
  .content .content_left{
    width: 100%;
  }
}
</style>
